import React from 'react'
import { get } from 'lodash'
import {
  Box,
  Grid,
  Button,
} from "@material-ui/core";
import { Stack, Checkbox, Typography } from '@mui/material'
import { useForm, Controller } from "react-hook-form";
import { TextField } from "./form/TextField";
import { CurrencyValue } from "./CurrencyValue";
import { getUserStoredCountry } from 'v2_actions/auth_country';
import { GalleryFormSectionHeading } from './GalleryFormSectionHeading'

export const GalleryPriceDiscountFormFields = ({
  classes,
  control,
  country,
  discountedValues,
  field_name_prefix
}) => {

  const labelStyling = {
    width: 130,
    fontWeight: 600,
    fontSize: 12,
    color: '#606060'
  }
  const discountPriceFieldSymbolStyling = {
    fontSize: 12,
    fontWeight: 600,
    display: 'inline-flex',
  }
  
  const renderDiscountPriceField = (fieldProps) => {
    return (
      <>
        <TextField
          type="text"
          variant="standard"
          fieldProps={ fieldProps }
          className={ classes.smallTextField }
          InputProps={{ disableUnderline: true }}
        />
        <Typography sx={labelStyling}>
          <Typography mx={'2px'} sx={discountPriceFieldSymbolStyling}>
            %
          </Typography>
          <Typography ml={'10px'} sx={discountPriceFieldSymbolStyling}>
            =
          </Typography>
          <Box className={classes.galleryPriceDiscountCurrencyValueWrapper}>
            <CurrencyValue
              country={ get(getUserStoredCountry(),'id')}
              horizontal_spacing={ true }
              value={ get(discountedValues, fieldProps.field.name) }
            />{" "}
            per photo
          </Box>
        </Typography>
      </>
    );
  };
  
  return (
    <div>
      <GalleryFormSectionHeading subHeading='Set Discounts of High Res Photos:'/>
      <Box display="flex" p={1} width="430px" alignItems="center">
        <Typography sx={labelStyling}>
          Photos 2-5:
        </Typography>

        <Controller
          name={`${field_name_prefix}.discount1_percentage`}
          control={control}
          render={renderDiscountPriceField}
        />
      </Box>
      <Box display="flex" p={1} width="430px" alignItems="center">
        <Typography sx={labelStyling}>
          photos 6-10:
        </Typography>
        <Controller
          name={`${field_name_prefix}.discount2_percentage`}
          control={control}
          render={renderDiscountPriceField}
        />
      </Box>
      <Box display="flex" p={1} width="430px" alignItems="center">
        <Typography sx={labelStyling}>
          Photos 11-50:
        </Typography>
        <Controller
          name={`${field_name_prefix}.discount3_percentage`}
          control={control}
          render={renderDiscountPriceField}
        />
      </Box>
      <Box display="flex" p={1} width="430px" alignItems="center">
        <Typography sx={labelStyling}>
          Photos 50+:
        </Typography>
        <Controller
          name={`${field_name_prefix}.discount4_percentage`}
          control={control}
          render={renderDiscountPriceField}
        />
      </Box>
    </div>
  )
}
